import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=194c4c7e&scoped=true&"
var script = {}
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=194c4c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194c4c7e",
  null
  
)

export default component.exports